import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useMeta } from 'vue-meta'
import GlobalFooter from '@/components/Footer.vue'
import GlobalHeader from '@/components/Header.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

useMeta({
  title: '',
  htmlAttrs: { lang: 'en', amp: true },
  meta: [
    {
      property: 'og:image',
      content: require(`@/assets/og_default.jpg`)
    }
  ]
})

return (_ctx: any,_cache: any) => {
  const _component_metainfo = _resolveComponent("metainfo")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_metainfo, null, {
      title: _withCtx(({ content }) => [
        _createTextVNode(_toDisplayString(content ? `ForeChamp | ${content}` : 'ForeChamp'), 1)
      ]),
      _: 1
    }),
    _createVNode(GlobalHeader),
    _createVNode(_component_router_view),
    _createVNode(GlobalFooter)
  ]))
}
}

})